export interface IPositionSkillsByPreference {
  ID: number;
  Alias: string;
  Name: string;
  DateInserted: string;
  DateModified: any;
  IsActive: boolean;
  IsMandatory: boolean;
  SkillFields: ISkillField[];
  SkillType: ISkillType;
  SkillGroupID: number;
  GroupAlias: string;
  GroupName: string;
  Sort: number;
  SkillValues: any;
  IsSpecialization: boolean;
  ContributedInRankSFID: number;
}

export class PositionSkillsByPreference implements IPositionSkillsByPreference {
  ID: number;
  Alias: string;
  Name: string;
  DateInserted: string;
  DateModified: any;
  IsActive: boolean;
  IsMandatory: boolean;
  SkillFields: ISkillField[];
  SkillType: ISkillType;
  SkillGroupID: number;
  GroupAlias: string;
  GroupName: string;
  Sort: number;
  SkillValues: any;
  IsSpecialization: boolean;
  ContributedInRankSFID: number;

  constructor(
    ID: number,
    Alias: string,
    Name: string,
    DateInserted: string,
    DateModified: any,
    IsActive: boolean,
    IsMandatory: boolean,
    SkillFields: ISkillField[],
    SkillType: ISkillType,
    SkillGroupID: number,
    GroupAlias: string,
    GroupName: string,
    Sort: number,
    SkillValues: any,
    IsSpecialization: boolean,
    ContributedInRankSFID: number
  ) {
    this.ID = ID;
    this.Alias = Alias;
    this.Name = Name;
    this.DateInserted = DateInserted;
    this.DateModified = DateModified;
    this.IsActive = IsActive;
    this.IsMandatory = IsMandatory;
    this.SkillFields = SkillFields;
    this.SkillType = SkillType;
    this.SkillGroupID = SkillGroupID;
    this.GroupAlias = GroupAlias;
    this.GroupName = GroupName;
    this.Sort = Sort;
    this.SkillValues = SkillValues;
    this.IsSpecialization = IsSpecialization;
    this.ContributedInRankSFID = ContributedInRankSFID;
  }
}

export interface ISkillField {
  id: string;
  skillId: string;
  placeholder: string;
  label: string;
  alias: string;
  type:
    | 'checkbox'
    | 'date'
    | 'dropdown'
    | 'number'
    | 'string'
    | 'tableForm'
    | 'hidden'
    | 'unknown';
  url: string;
  value: any;
  parentId: string;
  contributedInRank: boolean;
  isMandatory: boolean;
  minValue: number;
  maxValue: number;
  children: SkillField[];
  isHidden?: boolean;
  applicationSkillFields: any[];
}

export class SkillField implements ISkillField {
  id: string = '';
  value: any;
  skillId: string = '';
  placeholder: string = '';
  label: string = '';
  alias: string = '';
  type:
    | 'checkbox'
    | 'date'
    | 'dropdown'
    | 'number'
    | 'string'
    | 'tableForm'
    | 'hidden'
    | 'unknown' = 'unknown';
  url: string = '';
  isHidden?: boolean;
  parentId: string = '';
  contributedInRank: boolean = false;
  isMandatory: boolean = false;
  minValue: number = 0;
  maxValue: number = 0;
  children: SkillField[] = [];
  applicationSkillFields: any[] = [];

  constructor();
  constructor(obj: ISkillField);
  constructor(obj?: ISkillField) {
    if (obj) {
      this.id = obj.id;
      this.value = obj.value;
      this.skillId = obj.skillId;
      this.placeholder = obj.placeholder;
      this.label = obj.label;
      this.alias = obj.alias;
      this.type = obj.type;
      this.url = obj.url;
      this.parentId = obj.parentId;
      this.contributedInRank = obj.contributedInRank;
      this.isMandatory = obj.isMandatory;
      this.minValue = obj.minValue;
      this.maxValue = obj.maxValue;
      this.children = obj.children.map((child) => new SkillField(child));
      this.applicationSkillFields = obj.applicationSkillFields;
      this.isHidden = obj.isHidden ?? false;
    }
  }
}

export interface ISkillType {
  ID: number;
  Alias: string;
  Name: string;
  DateInserted: string;
  DateModified: any;
  IsActive: boolean;
  Sort: number;
}

export class SkillType implements ISkillType {
  ID: number;
  Alias: string;
  Name: string;
  DateInserted: string;
  DateModified: any;
  IsActive: boolean;
  Sort: number;

  constructor(
    ID: number,
    Alias: string,
    Name: string,
    DateInserted: string,
    DateModified: any,
    IsActive: boolean,
    Sort: number
  ) {
    this.ID = ID;
    this.Alias = Alias;
    this.Name = Name;
    this.DateInserted = DateInserted;
    this.DateModified = DateModified;
    this.IsActive = IsActive;
    this.Sort = Sort;
  }
}
